export enum TicketStage {
  NEW = '1',
  WAITING_ON_CONTACT = '2',
  WAITING_ON_US = '3',
  CLOSED = '4',
}

export const ticketStageColor: Record<TicketStage, string> = {
  [TicketStage.CLOSED]: 'error',
  [TicketStage.NEW]: 'success',
  [TicketStage.WAITING_ON_US]: 'info',
  [TicketStage.WAITING_ON_CONTACT]: 'warning',
};

export const ticketStageIcon: Record<TicketStage, string> = {
  [TicketStage.CLOSED]: 'mdi-lock',
  [TicketStage.NEW]: 'mdi-star',
  [TicketStage.WAITING_ON_US]: 'mdi-clipboard-clock',
  [TicketStage.WAITING_ON_CONTACT]: 'mdi-message-text-clock',
};
